// import React, { useState } from "react";
// import OrganizationGeneral from "../OrganizationSetting/General/index";
// import OrganizationNotification from "../OrganizationSetting/Notification/index";
// import OrganizationBilling from "../OrganizationSetting/Billing/index";
// import Settings from "components/Settings/SettingsMain/index";
// import OrganizationSecurity from "./Security/index";

// import "./settings.scss";
// // import useTheme from "hooks/observer";
// import ManageUser from "./ManageUser/index";
// import ChangePlan from "components/ChangePlan/index";

// function OrganizationSetting({ handleManage, setChangePlan, setManageUser }) {
//   const [activeTab, setActiveTab] = useState(0);
//   const [editProfile, setEditProfile] = useState(false);

//   const OrganizationTabs = [
//     <OrganizationGeneral
//       key={0}
//       handleManage={handleManage}
//       editProfile={editProfile}
//       setEditProfile={setEditProfile}
//       setManageUser={setManageUser}
//     />,
//     <OrganizationSecurity key={1} setManageUser={setManageUser} />,
//     <OrganizationNotification key={2} />,
//     <OrganizationBilling key={3} setChangePlan={setChangePlan} />
//   ];

//   // const theme = useTheme();

//   return (
//     <div
//       className="OrganizationSetting"
//       // style={{ backgroundColor: theme === "light" ? "#fff" : "#211D25" }}
//     >
//       <Settings activeTab={activeTab} setActiveTab={setActiveTab} />
//       <div
//         className={`OrganizationSettingWrapper ${editProfile ? "OrganizationSettingScroll" : ""}`}
//       >
//         {OrganizationTabs[activeTab]}
//       </div>
//     </div>
//   );
// }

// function OrganizationSettings() {
//   const [manageUser, setManageUser] = useState(false);
//   const [changePlan, setChangePlan] = useState(false);

//   const handleManage = () => {
//     setManageUser(true);
//   };
//   return changePlan ? (
//     <ChangePlan setChangePlan={setChangePlan} />
//   ) : (
//     <>
//       {manageUser ? (
//         <ManageUser setManageUser={setManageUser} />
//       ) : (
//         <OrganizationSetting
//           handleManage={handleManage}
//           setChangePlan={setChangePlan}
//           setManageUser={setManageUser}
//         />
//       )}
//     </>
//   );
// }

// export default OrganizationSettings;

import React, { useState, useEffect } from "react";
import OrganizationGeneral from "../OrganizationSetting/General/index";
// import OrganizationNotification from "../OrganizationSetting/Notification/index";
// import OrganizationBilling from "../OrganizationSetting/Billing/index";
import Settings from "components/Settings/SettingsMain/index";
import OrganizationSecurity from "./Security/index";
import Admin from "./Admin/index";


import "./settings.scss";
import ChangePlan from "components/ChangePlan/index";
import ManageTeam from "./ManageTeam/index";
import ManageRole from "./ManageRole/index";
import AdvancedSettingsPage from "./AdvancedSettings/index";
// import Logs from "components/Logs/Logs"; // Moved to Ysentinel dropdown
import ManageUser from "./ManageUser/ManageUser";

function OrganizationSetting({
  handleManage,
  setChangePlan,
  setManageUser,
  handleManageTeam,
  handleManageRole,
  handleManageAdvanced,
  onProfileUpdated
}) {
  // Initialize activeTab from sessionStorage or default to 0
  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = sessionStorage.getItem("activeTab");
    return savedTab !== null ? parseInt(savedTab, 10) : 0;
  });
  const [editProfile, setEditProfile] = useState(false);

  // Save activeTab to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem("activeTab", activeTab);
  }, [activeTab]);

  // Read activeTab from sessionStorage when component mounts
  useEffect(() => {
    const savedTab = sessionStorage.getItem("activeTab");
    if (savedTab !== null) {
      setActiveTab(parseInt(savedTab, 10));
    }

    // Listen for the updateSettingsTab event
    const handleUpdateSettingsTab = () => {
      const savedTab = sessionStorage.getItem("activeTab");
      if (savedTab !== null) {
        setActiveTab(parseInt(savedTab, 10));
      }
    };

    window.addEventListener("updateSettingsTab", handleUpdateSettingsTab);

    return () => {
      window.removeEventListener("updateSettingsTab", handleUpdateSettingsTab);
    };
  }, []);

  const userType = sessionStorage.getItem("usertype");
  
  const OrganizationTabs = userType === "SuperAdmin" 
    ? [
        <OrganizationGeneral
          key={0}
          handleManage={handleManage}
          editProfile={editProfile}
          setEditProfile={setEditProfile}
          setManageUser={setManageUser}
          handleManageTeam={handleManageTeam}
          handleManageRole={handleManageRole}
          onProfileUpdated={onProfileUpdated}
        />,
        <OrganizationSecurity key={1} setManageUser={setManageUser} />,
        <Admin key={2}
          handleManage={handleManage}
          handleManageTeam={handleManageTeam}
          handleManageRole={handleManageRole}
          handleManageAdvanced={handleManageAdvanced}
        />
      ]
    : [
        <OrganizationGeneral
          key={0}
          handleManage={handleManage}
          editProfile={editProfile}
          setEditProfile={setEditProfile}
          setManageUser={setManageUser}
          handleManageTeam={handleManageTeam}
          handleManageRole={handleManageRole}
          onProfileUpdated={onProfileUpdated}
        />,
        <OrganizationSecurity key={1} setManageUser={setManageUser} />
      ];

  

  return (
    <div className="OrganizationSetting">
      <Settings activeTab={activeTab} setActiveTab={setActiveTab} />
      <div
        className={`OrganizationSettingWrapper ${editProfile ? "OrganizationSettingScroll" : ""}`}
      >
        {OrganizationTabs[activeTab] || OrganizationTabs[0]}
      </div>
    </div>
  );
}

function OrganizationSettings({ searchQuery, setSearchQuery, manageTeamSearchQuery, setManageTeamSearchQuery, manageRoleSearchQuery, setManageRoleSearchQuery, onManageUserChange, onProfileUpdated }) {
  const [manageUser, setManageUser] = useState("");
  const [changePlan, setChangePlan] = useState(() => {
    // Check if we should open the Change Plan component directly
    const shouldOpenChangePlan =
      sessionStorage.getItem("openChangePlan") === "true";
    if (shouldOpenChangePlan) {
      // Clear the flag so it doesn't persist on page refresh
      sessionStorage.removeItem("openChangePlan");
      return true;
    }
    return false;
  });

  const handleManage = () => {
    setManageUser("manageUser");
    onManageUserChange("manageUser");
  };

  const handleManageTeam = () => {
    setManageUser("manageTeam");
    onManageUserChange("manageTeam");
  };

  const handleManageRole = () => {
    setManageUser("manageRole");
    onManageUserChange("manageRole");
  };

  const handleManageAdvanced = () => {
    setManageUser("advancedSettings");
    onManageUserChange("advancedSettings");
  };

  const handleManageUserChange = (newState) => {
    setManageUser(newState);
    onManageUserChange(newState);
  };

  return changePlan ? (
    <ChangePlan setChangePlan={setChangePlan} />
  ) : (
    <>
      {manageUser === "manageUser" ? (
        <ManageUser setManageUser={handleManageUserChange} searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
      ) : manageUser === "manageTeam" ? (
        <ManageTeam setManageUser={handleManageUserChange} searchQuery={manageTeamSearchQuery} setSearchQuery={setManageTeamSearchQuery} />
      ) : manageUser === "manageRole" ? (
        <ManageRole setManageUser={handleManageUserChange} searchQuery={manageRoleSearchQuery} setSearchQuery={setManageRoleSearchQuery} />
      ) : manageUser === "advancedSettings" ? (
        <AdvancedSettingsPage setManageUser={handleManageUserChange} />
      ) : (
        <OrganizationSetting
          handleManage={handleManage}
          setChangePlan={setChangePlan}
          setManageUser={handleManageUserChange}
          handleManageTeam={handleManageTeam}
          handleManageRole={handleManageRole}
          handleManageAdvanced={handleManageAdvanced}
          onProfileUpdated={onProfileUpdated}
        />
      )}
    </>
  );
}

export default OrganizationSettings;
